<template>
  <div>
    <div v-if="solution" class="my-6">
      <h1 v-if="legCorrect" class="heading text-4xl">Well Done!</h1>
      <template v-else>
        <h1 class="heading text-4xl">
          Sorry
        </h1>
        <h3 class="font-main font-semibold text-2xl">
          The Correct Answer is {{ solution }}
        </h3>
      </template>
    </div>
    <div class="my-6">
      <h1 v-if="!solution" class="heading text-4xl">Ready?</h1>
      <button class="button blue" @click="$emit('nextPuzzle')">
        Next Puzzle
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    solution: {
      type: String,
      default: '',
    },
    legCorrect: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
